import { MIN_PART_NUMBER_LEN, SELECTION_ANY } from '../../../components/bearing-search/api/api';
import { SealInterchangePayload, TimkenUnitDimension } from '../../../components/bearing-search/types/types';
import { handleActionError } from '../../utils/engineering-tools';

export type InterchangeSearchState = {
	brandPartNumber: string;
	brandName: string;
	unitDimension: TimkenUnitDimension;
	requestData?: SealInterchangePayload;
	isPartNumberValid: boolean;
	isValidated: boolean;
};

export const initialSealInterchangeState: InterchangeSearchState = {
	brandPartNumber: '',
	brandName: SELECTION_ANY,
	unitDimension: 'Metric',
	isPartNumberValid: false,
	isValidated: false,
};

export type InterchangeSearchAction =
	| { type: 'change_part_number'; payload: string; }
	| { type: 'change_brand'; payload: string; }
	| { type: 'change_unit'; payload: TimkenUnitDimension; }
	| { type: 'change_validation_flag'; payload: boolean; }
	| { type: 'update_request_data'; }
	| { type: 'reset'; payload?: InterchangeSearchState; };

const sealInterchangeReducer: React.Reducer<
	InterchangeSearchState,
	InterchangeSearchAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_part_number': {
			const brandPartNumber = action.payload;
			const isPartNumberValid = brandPartNumber.trim().length >= MIN_PART_NUMBER_LEN;

			return {
				...state,
				brandPartNumber,
				isPartNumberValid,
				isValidated: false,
			};
		}
		case 'change_brand': {
			return {
				...state,
				brandName: action.payload,
			};
		}
		case 'change_unit': {
			return {
				...state,
				unitDimension: action.payload,
			};
		}
		case 'change_validation_flag': {
			return {
				...state,
				isValidated: action.payload,
			};
		}
		case 'update_request_data': {
			const requestData = state.isPartNumberValid
				? { brandName: state.brandName === SELECTION_ANY ? '' : state.brandName, brandPartNumber: state.brandPartNumber }
				: undefined;

			return {
				...state,
				requestData,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialSealInterchangeState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default sealInterchangeReducer;
